<template>
  <div ref="filters" class="col-3 desktop-filters__wrapper d-none d-lg-block">
    <div class="desktop-filters">
      <h4 class="mb-16">
        {{ $label('page.shop.filters.genre') }}
      </h4>
      <div v-for="filter in filters" :key="filter.id">
        <button
          id="gtm-track"
          :data-testid="`filter-btn_${filter.id}`"
          :class="[
            'btn filter-btn reset-btn-styling',
            { 'filter-btn--active': filter.id === selectedFilter },
          ]"
          @click="() => onDesktopFilterClick(filter)"
        >
          {{ filter.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
    selectedFilter: {
      type: String,
      default: '',
    },
    onFilterClick: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onDesktopFilterClick(filter) {
      this.onFilterClick(filter.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.desktop-filters__wrapper {
  scroll-margin: 20px;
}

.desktop-filters {
  position: sticky;
  top: 18px;
}

.filter-btn {
  color: $bc-green;
  padding-bottom: 8px;
  margin-bottom: 8px;
  font-size: $font-size-base;
  font-weight: normal;
  text-align: left;
  border-radius: unset !important;

  &:hover,
  &:focus {
    color: $bc-green;
  }

  &:hover {
    text-decoration: underline;
  }
}

.filter-btn--active {
  font-weight: $font-weight-semibold;
}
</style>
